import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import axios from "axios";

import { Button, DialogActions } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { Snackbar, Alert } from "@mui/material";

import "../ReplanLoan/ReplanLoan.scss";
import { fetchAPIData } from "../../../service/service";

class ReplanLoan extends Component {
    constructor() {
        super();

        this.state = {
            isConfirmReplan: false,
            date: "",
            open: false,
            totalReplanAmount:"",
            alertToast: {
                msg: "",
                time: 2000,
                variant: "success",
            },
        };
    }

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleDateChange = (e) => {
        this.setState({
            date: e.target.value,
        });
    };

    openConfirmDialog = () => {
        const { date } = this.state;

        if (!date) {
            alert("Please select a closing date.");
            return;
        }

        this.setState({
            isConfirmReplan: true,
        });
    };

    confirmReplanToogle = async (confirmed) => {
        if (confirmed) {
            await this.onSubmitClk();
        }

        this.setState({
            isConfirmReplan: false,
        });
    };

    onSubmitClk = async () => {
        const { date } = this.state;

        if (!date) {
            alert("Please select a closing date.");
            return;
        }

        try {
            const payload = {
                loanId: this.props.loanId,
            };

            const loanDetailsRes = await fetchAPIData("getLoanDetailsByID",this.props.loanId);

            const loanDetails = loanDetailsRes?.data?.data;

            // const res = await fetchAPIData("replanLoan", payload);

            // if (res) {
            //     this.setState({
            //         alertToast: {
            //             msg: "Loan replanned successfully",
            //             time: 1500,
            //             variant: "success",
            //         },
            //         date: "",
            //         open: true,
            //     });

                this.props.replan("confirm");

                setTimeout(() => {
                    this.props.history.push({
                        pathname: "/addloannointerest",
                        params: {
                            midReplan: true,
                            loanDetails,
                            closingDate: this.state.date,
                            previousLoanId: this.props.loanId,
                        },
                    });
                }, 1500);
            // } else {
            //     this.setState({
            //         alertToast: {
            //             msg: "Something went wrong",
            //             time: 3000,
            //             variant: "error",
            //         },
            //         open: true,
            //     });
            // }
        } catch (error) {
            console.error("Replan Loan Error:", error);

            this.setState({
                alertToast: {
                    msg:
                        error?.response?.data?.message ||
                        error?.message ||
                        "Something went wrong",
                    time: 3000,
                    variant: "error",
                },
                open: true,
            });
        }
    };

    render() {
        const { replan } = this.props;
        const { isConfirmReplan, alertToast, open, date } = this.state;

        return (
            <>
                <Snackbar
                    open={open}
                    autoHideDuration={alertToast?.time}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                    onClose={this.handleClose}
                >
                    <Alert
                        onClose={this.handleClose}
                        severity={alertToast?.variant}
                        variant="filled"
                        sx={{ width: "100%" }}
                    >
                        {alertToast?.msg}
                    </Alert>
                </Snackbar>

                <div className="deleteuserpage">
                    <Dialog
                        open={this.props.open}
                        className="closeCustomerDialogbox"
                    >
                        <DialogTitle
                            id="customized-dialog-title"
                            className="TitleDiv"
                        >
                            Replan Loan

                            <div className="deleteconfirmation">
                                <div className="Fonts btnSizeFont confrmmessage">
                                    By replanning the loan, you cannot revert
                                    the process.
                                </div>

                                <div className="dateFieldWrapper">
                                    <div className="amountLabel Fonts">
                                        Replanned Date
                                    </div>

                                    <input
                                        id="closingDate"
                                        type="date"
                                        className="datePicker"
                                        value={date}
                                        onChange={this.handleDateChange}
                                    />
                                </div>
                            </div>
                        </DialogTitle>

                        <DialogContent className="bottomPart">
                            <div className="buttonDiv">
                                <Button
                                    className="replanbutton Fonts"
                                    onClick={() => replan("replan")}
                                >
                                    Close
                                </Button>

                                <Button
                                    className="savebutton Fonts"
                                    onClick={this.openConfirmDialog}
                                    disabled={!date}
                                >
                                    Confirm
                                </Button>
                            </div>
                        </DialogContent>
                    </Dialog>

                    <ConfirmReplan
                        open={isConfirmReplan}
                        closeAction={this.confirmReplanToogle}
                    />
                </div>
            </>
        );
    }
}

const ConfirmReplan = ({ open, closeAction }) => {
    return (
        <Dialog open={open}>
            <DialogTitle>Are you sure?</DialogTitle>

            <DialogActions>
                <Button
                    className="confirm"
                    onClick={() => closeAction(true)}
                >
                    Yes
                </Button>

                <Button
                    className="confirm"
                    onClick={() => closeAction(false)}
                >
                    No
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withRouter(ReplanLoan);